/**
 *
 * @param error {AxiosError}
 * @param statusCodes {Array<number>} [401]
 * @returns {boolean} - Return true if you want to intercept the request
 */
export const shouldIntercept = (error, statusCodes = [401]) => {
  try {
    return statusCodes.findIndex(status => error.response.status === status) > -1;
  } catch (e) {
    return false;
  }
};

const setTokenData = (tokenData = {}, axiosClient) => {

};

const handleTokenRefresh = (axiosClient) => {

};

const attachTokenToRequest = (request, token) => {
  request.headers['Authorization'] = 'Bearer ' + token;
};

/**
 *
 * @param axiosClient
 * @param customOptions
 * @param customOptions.statusCodes
 * @param customOptions.attachTokenToRequest
 * @param customOptions.handleTokenRefresh
 * @param customOptions.setTokenData
 * @param customOptions.shouldIntercept
 */
export default function refreshTokenInterceptor(axiosClient, customOptions = {}) {
  let isRefreshing = false;
  let failedQueue = [];

  const options = {
    attachTokenToRequest,
    handleTokenRefresh,
    setTokenData,
    shouldIntercept,
    ...customOptions,
  };
  const processQueue = (error, token = null) => {
    failedQueue.forEach(prom => {
      if (error) {
        prom.reject(error);
      } else {
        prom.resolve(token);
      }
    });

    failedQueue = [];
  };

  const interceptor = (error) => {
    if (!options.shouldIntercept(error, options.statusCodes)) {
      return Promise.reject(error);
    }

    if (error.config._retry || error.config._queued) {
      return Promise.reject(error);
    }

    const originalRequest = error.config;
    if (isRefreshing) {
      return new Promise(function (resolve, reject) {
        failedQueue.push({resolve, reject})
      }).then(token => {
        originalRequest._queued = true;
        options.attachTokenToRequest(originalRequest, token);
        return axiosClient.request(originalRequest);
      }).catch(err => {
        return Promise.reject(error); // Ignore refresh token request's "err" and return actual "error" for the original request
      })
    }

    originalRequest._retry = true;
    isRefreshing = true;
    return new Promise((resolve, reject) => {
      options.handleTokenRefresh.call(options.handleTokenRefresh, axiosClient)
        .then((tokenData) => {
          options.setTokenData(tokenData, axiosClient);
          options.attachTokenToRequest(originalRequest, tokenData);
          processQueue(null, tokenData);
          resolve(axiosClient.request(originalRequest));
        })
        .catch((err) => {
          processQueue(err, null);
          reject(err);
        })
        .finally(() => {
          isRefreshing = false;
        })
    });
  };

  axiosClient.interceptors.response.use(undefined, interceptor);
};
